import React, { useRef } from 'react';
var VeltAutocompleteEmpty = function (props) {
    var newUserContactError = props.newUserContactError, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-empty", { ref: ref, "new-user-contact-error": newUserContactError, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltAutocompleteEmpty;
